<template>
  <span class="text-no-wrap">
    {{ contractTypeName }}
    <v-tooltip bottom color="black">
      <template #activator="{ on }">
        <v-icon small v-on="on" color="info" class="ml-1">{{ contractIcon }}</v-icon>
      </template>
      <div v-for="key in keys" :key="key.type" class="d-flex align-center">
        <v-icon small color="white" class="mr-2">{{ key.icon }}</v-icon>
        <span class="body-2 white--text">{{ key.value }}</span>
      </div>
    </v-tooltip>
  </span>
</template>

<script>
import { ContractType } from '@/utils/Enumerations'
import IconHelpers from '@/utils/IconHelpers'

export default {
  name: 'ContractKeyTooltip',

  props: {
    type: { type: Number, default: undefined },
    fromAccount: { type: String, default: undefined },
    destinationAccount: { type: String, default: undefined },
    account: { type: String, default: undefined }
  },

  computed: {
    contractTypeName () {
      return `${ContractType.fromInt(this.type)} ${this.$t('contract')}`
    },

    contractIcon () {
      return IconHelpers.getIconForObjectType('contract')
    },

    keys () {
      return [
        { type: 'fromAccount', value: this.fromAccount },
        { type: 'destination', value: this.destinationAccount },
        { type: 'account', value: this.account }
      ].filter(key => key.value).map(key => ({
        ...key,
        icon: IconHelpers.getIconForObjectType(key.type)
      }))
    }
  }
}
</script>
